import { PageSearchAndReplaceFormValidationSchema } from '@/modules/Pages';

export const pageSearchAndReplaceFormValidationSchema: PageSearchAndReplaceFormValidationSchema = {
  searchFor: [
    { required: true, message: 'Введіть слово, яке потрібно замінити' },
    { type: 'string', message: 'Cлово, яке потрібно замінити має бути строкою' },
  ],
  replaceWith: [{ required: false }],
  matchCase: [{ required: false, type: 'boolean' }],
  wholeWord: [{ required: false, type: 'boolean' }],
  useRegex: [{ required: false, type: 'boolean' }],
};
